enum PermissionEnum {
  STUDY_EDIT = 'STUDIES_EDIT',
}

export default PermissionEnum;
